import { createRoot } from "react-dom/client";
import React from 'react';
import { Provider } from 'react-redux'
import { configureStore } from '@reduxjs/toolkit'
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import reducer from './utils/reducers';

import 'bootstrap/dist/css/bootstrap.min.css';

const preloadedState = {
  products: [],
  cart: [],
  cartOpen: false,
  categories: [],
  currentCategory: '',
};

const store = configureStore(
    {
      reducer,
      preloadedState
    }
  );

const root = createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
